import { jsx as _jsx } from "react/jsx-runtime";
import { ForumCategoryItem } from "@bluframe/mightychroma-mightytool-ui";
const Add = ({ onCancel, onSave }) => (_jsx(ForumCategoryItem, { isAdd: true, onCancel: onCancel, onSave: onSave }));
export default Add;
